/*
 * Public API Surface of sham-configs
 */

export * from './lib/devextreme-license';
